"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var spaui_1 = require("@tencent/spaui");
var utils_1 = require("./utils");
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var emptyArray = [];
var NumberInput = function NumberInput(props) {
  var _a = props.min,
    min = _a === void 0 ? 0 : _a,
    max = props.max,
    _b = props.step,
    step = _b === void 0 ? 1 : _b,
    value = props.value,
    error = props.error,
    _c = props.status,
    status = _c === void 0 ? 'normal' : _c,
    statusText = props.statusText,
    _d = props.onChange,
    _onChange = _d === void 0 ? spaui_utils_1.noop : _d,
    buttonPosition = props.buttonPosition,
    _e = props.buttonDisabled,
    buttonDisabled = _e === void 0 ? emptyArray : _e,
    _f = props.disabled,
    disabled = _f === void 0 ? false : _f,
    unit = props.unit;
  var changeValue = (0, react_1.useCallback)(function (event, type) {
    var result = type === '+' ? (0, utils_1.accAdd)(Number(value), step) : (0, utils_1.accAdd)(Number(value), -1 * step);
    if (max) {
      if (result >= min && result <= max) {
        _onChange(event, result);
      }
    } else if (result >= min) {
      _onChange(event, result);
    }
  }, [_onChange, value, max, min, step]);
  var plusButtonDisabled = disabled;
  var minusButtonDisabled = disabled;
  if ((0, spaui_utils_1.isArray)(buttonDisabled)) {
    if (buttonDisabled.includes('plus')) {
      plusButtonDisabled = true;
    }
    if (buttonDisabled.includes('minus')) {
      minusButtonDisabled = true;
    }
  }
  return react_1["default"].createElement("div", __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: 'base-number-input',
    supportAllEvents: true
  }, NumberInput)), buttonPosition === 'right' ? react_1["default"].createElement("div", {
    className: "relative spaui-input-numder-t2"
  }, react_1["default"].createElement(spaui_1.FormGroup, {
    error: error,
    status: status,
    helpBlock: statusText
  }, react_1["default"].createElement(spaui_1.Input, {
    value: "".concat(unit ? value + unit : value),
    onChange: function onChange(event, newValue) {
      _onChange(event, newValue);
    },
    disabled: disabled
  })), react_1["default"].createElement("div", {
    className: "absolute flex flex-column spaui-input-numder-t2-btn"
  }, react_1["default"].createElement(spaui_1.Button, {
    className: "flex-center",
    disabled: plusButtonDisabled,
    onClick: function onClick(event) {
      return changeValue(event, '+');
    }
  }, react_1["default"].createElement(spaui_1.Icon, {
    name: "dropdown-arrow-outlined"
  })), react_1["default"].createElement(spaui_1.Button, {
    className: "flex-center",
    disabled: minusButtonDisabled,
    onClick: function onClick(event) {
      return changeValue(event, '-');
    }
  }, react_1["default"].createElement(spaui_1.Icon, {
    name: "dropdown-arrow-outlined"
  })))) : react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(spaui_1.Button, {
    disabled: minusButtonDisabled,
    onClick: function onClick(event) {
      return changeValue(event, '-');
    }
  }, react_1["default"].createElement("i", {
    className: "spaui-icon spaui-icon-minus"
  })), react_1["default"].createElement(spaui_1.FormGroup, {
    error: error,
    status: status,
    helpBlock: statusText
  }, react_1["default"].createElement(spaui_1.Input, {
    value: value,
    onChange: function onChange(event, newValue) {
      _onChange(event, newValue);
    },
    disabled: disabled
  })), react_1["default"].createElement(spaui_1.Button, {
    disabled: plusButtonDisabled,
    onClick: function onClick(event) {
      return changeValue(event, '+');
    }
  }, react_1["default"].createElement("i", {
    className: "spaui-icon spaui-icon-plus"
  }))));
};
(0, spaui_utils_1.setComponentMark)(NumberInput, info_1["default"]);
exports["default"] = react_1["default"].memo(NumberInput);